<div class="nav-container">
    <div class="progress-bar">
        <div [ngClass]="progressPercentage == 100 ? 'progress-fill-complete' : 'progress-fill'"
        [style.width.%]="progressPercentage"></div>
    </div>
</div>